module.exports = __webpack_public_path__ + "img/ZB52_09.1c85ba04.jpg";